module.exports = __webpack_public_path__ + "static/media/Delete.6e391ab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/Delete.svg
// module id = 659
// module chunks = 0